import firebase, {db, auth, fc} from './connection'

export default {
    getAll() {
        let ref = db.collection('centers');
    
        return ref.get()
                .then(query => {
                    return {status: true, query: query};
                })
                .catch(error => {
                    return error;
                });
    },

    add(model) {
        let batch = db.batch();
        let ref1 = db.collection('centers').doc();
        let ref2 = db.collection('users').doc(model.director.id);

        batch.set(ref1, model);
        batch.update(ref2, {center: ref1.id});

        return batch.commit()
                    .then(doc => {
                        return true;
                    })
                    .catch(error => {
                        return error;
                    });
    
        // return ref.add(model)
        //         .then(doc => {
        //             return true;
        //         })
        //         .catch(error => {
        //             return error;
        //         });
    },

    get(id) {
        let ref = db.collection('centers').doc(id);
    
        return ref.get()
                .then(doc => {
                    return {status: true, doc: doc};
                })
                .catch(error => {
                    return error;
                });
    },


    // save(uid, clientId, model) {
    //     let ref1 = db.collection('users').doc(uid).collection('clients').doc(clientId);
    //     let ref2 = db.collection('users').doc(uid).collection('celebs').where('client.id', '==', clientId);
    //     let ref3 = db.collection('users').doc(uid).collection('policies').where('client.id', '==', clientId);

    //     delete model.id;

    //     return ref2.get()
    //                 .then(query => {
    //                     let batch = db.batch();

    //                     if (query.empty === false) {
    //                         query.forEach(dt => {
    //                             let refTempo = db.collection('users').doc(uid).collection('celebs').doc(dt.id);
    //                             batch.update(refTempo, {client: {id:clientId, name:model.name}})
    //                         });
    //                     }

    //                     return ref3.get()
    //                                 .then(query => {
    //                                     if (query.empty === false) {
    //                                         query.forEach(dt => {
    //                                             let refTempo = db.collection('users').doc(uid).collection('policies').doc(dt.id);
    //                                             batch.update(refTempo, {client: {id:clientId, name:model.name}})
    //                                         });
    //                                     }

    //                                     batch.update(ref1, model);

    //                                     return batch.commit()
    //                                             .then( () => {
    //                                                 return true;
    //                                             })
    //                                             .catch(error => {
    //                                                 console.log(error)
    //                                                 return error;
    //                                             });
    //                                 });
    //                 })
    //                 .catch(error => {
    //                     return error;
    //                 });
    // },

    // remove(clientId) {
    //     let deleteClient = fc.httpsCallable('deleteClient');

    //     return deleteClient({id: clientId})
    //                 .then(response => {
    //                     if (response.data === true) {
    //                         return true;
    //                     } else {
    //                         return response;
    //                     }
    //                 })
    //                 .catch(error => {
    //                     return error;
    //                 });
    // }
}